import GroupService from '@/service/group-document'
export default {
  getListGroupDocument ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupService.getListGroupDocument(payload.page, payload.per_page, payload.status).then(res => {
        commit('getListGroupDocument', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  createGroupDocument ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupService.createGroupDocument(payload.group_document).then(res => {
        commit('addRoot', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  addGroupDocumentChildren ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupService.createGroupDocument(payload.group_document).then(res => {
        console.log(res.data.data)
        commit('addGroupDocumentChildren', res.data.data)
        resolve(res.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  showGroupDocument ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupService.showGroupDocument(payload.group_document).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  updateGroupDocument ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupService.updateGroupDocument(payload.group_document).then(res => {
        commit('updateGroupDocument', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  destroyGroupDocument ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupService.destroyGroupDocument(payload.group_document).then(res => {
        commit('destroyGroupDocument', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  approvalGroupDocument ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      GroupService.approvalGroupDocument(payload.group_document).then(res => {
        if (res.status === 200) {
          resolve(res.data.data)
        }
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  rejectGroupDocument ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      GroupService.rejectGroupDocument(payload.group_document).then(res => {
        if (res.status === 200) {
          resolve(res.data.data)
        }
      }).catch(errors => {
        reject(errors)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/group-document/actions.js